{
  "indoorstations": [
    "ISW3030-0140",
    "ISW5030-0145",
    "ISW3330-0140",
    "ISW5010-0145",
    "ISW5031-0145",
    "ISW5033-0145",
    "ISW6031-0145",
    "ISW7030-0140",
    "ISH7030-0140",
    "ISW3130-0140",
    "CAI2000-0150",
    "CAI2000-0151",
    "CAI2000-0152",
    "CAI2000-0156",
    "CAI2001-0150",
    "CAI2002-0140",
    "CAI2010-0150",
    "CAI2010-0151",
    "CAI2010-0152",
    "CAI2010-0156",
    "CAI2300-0150",
    "CAI2300-0151",
    "CAI2300-0152",
    "CAI2300-0156",
    "IMM1100-0140",
    "IMM1110-0140",
    "IMM1300-0140",
    "IMM1310-0140",
    "IMM1500-0140",
    "IMM2100-0140",
    "IMM2110-0140",
    "IMM2300-0140",
    "IMM2310-0140",
    "ISH3030-0140",
    "ISH3130-0140",
    "ISH3230-0140",
    "ISH3240-0140",
    "ISW3230-0140",
    "IVH3222-0140",
    "IVH4222-0140",
    "IVH7510-0140",
    "IVW2221-0153",
    "IVW5110-0145",
    "IVW5111-0145",
    "IVW5211-0145",
    "IVW5411-0145",
    "IVW5511-0145",
    "IVW7510-0140",
    "IVW9000-0110",
    "IVW9020-0110",
    "IVW9030-0140",
    "IVW9110-0187",
    "ISW3231-0140",
    "ISW6010-0145",
    "IVW2221-0155",
    "210010657-00",
    "200049080-01",
    "200037008-00",
    "200040023-00",
    "200040116-00",
    "200049270-01",
    "200040578-00",
    "210005918-00",
    "IVW9110-0000",
    "IVW9110-RAL",
    "ISWM7000-0140",
    "ISHM7000-0140",
    "ISH7032-0140",
    "IVH7512-0140",
    "ISW7032-0140",
    "IVH7510-1140",
    "IVW7510-1140",
    "ISH7030-1140",
    "ISW7030-1140",
    "IVW7512-0140",
    "ISWM7200-0140",
    "CAI2000-1156",
    "ISW3340-0140",
    "CAI2400-0156",
    "CAI2500-0156",
    "IVW3012-0210",
    "CAI2400-0150",
    "IVW6521-0145",
    "IVW6511-0145"
  ],
  "outdoorstations": [
    "ASA101000-0010",
    "ASA110101-0010",
    "ASA110103-0010",
    "ASA110104-0010",
    "ASA110206-0010",
    "ASA110208-0010",
    "ASA120210-0010",
    "ASA120212-0010",
    "ASA120214-0010",
    "ASA120216-0010",
    "ASA130218-0010",
    "ASA130220-0010",
    "ASA130222-0010",
    "ASA130224-0010",
    "ASB01010-0210",
    "ASB01010-0230",
    "ASB01020-0210",
    "ASB01020-0230",
    "ASB01030-0210",
    "ASB01030-0230",
    "ASB01040-0210",
    "ASB01040-0230",
    "ASB01050-0210",
    "ASB01050-0230",
    "ASB01060-0210",
    "ASB01060-0230",
    "ASB01070-0210",
    "ASB01070-0230",
    "ASB01080-0210",
    "ASB01080-0230",
    "ASB01090-0210",
    "ASB01090-0230",
    "ASB01100-0210",
    "ASB01100-0230",
    "ASB02080-0210",
    "ASB02080-0230",
    "ASB02100-0210",
    "ASB02100-0230",
    "ASB02120-0210",
    "ASB02120-0230",
    "ASB02140-0210",
    "ASB02140-0230",
    "ASB02160-0210",
    "ASB02160-0230",
    "ASB02180-0210",
    "ASB02180-0230",
    "ASB02200-0210",
    "ASB02200-0230",
    "ASB03120-0210",
    "ASB03120-0230",
    "ASB03150-0210",
    "ASB03150-0230",
    "ASB03180-0210",
    "ASB03180-0230",
    "ASB03210-0210",
    "ASB03210-0230",
    "ASB03240-0210",
    "ASB03240-0230",
    "ASB03270-0210",
    "ASB03270-0230",
    "ASB03300-0210",
    "ASB03300-0230",
    "ASD51010-0010",
    "ASE51040-0010",
    "ASE51060-0010",
    "ASE51080-0010",
    "ASE51100-0010",
    "ASE51120-0010",
    "ASE51140-0010",
    "ASE51160-0010",
    "ASI12000-0000",
    "ASI12010-0000",
    "ASI21000-0000",
    "ASI31000-0000",
    "ASI91000-0000",
    "ASN01010-0210",
    "ASN01010-0230",
    "ASN01040-0210",
    "ASU101100-0010",
    "ASU101200-0010",
    "ASU101300-0010",
    "ASX13001-0010",
    "ASX13002-0010",
    "ASX13003-0010",
    "ASX13004-0010",
    "ASX13005-0010",
    "ASX13006-0010",
    "AVA101000-0010",
    "AVA210101-0010",
    "AVA210102-0010",
    "AVA210103-0010",
    "AVA210104-0010",
    "AVA210106-0010",
    "AVA210108-0010",
    "AVA210206-0010",
    "AVA210208-0010",
    "AVA220210-0010",
    "AVA220212-0010",
    "AVA220214-0010",
    "AVA220216-0010",
    "AVA230218-0010",
    "AVA230220-0010",
    "AVA230222-0010",
    "AVA230224-0010",
    "AVA410101-0010",
    "AVA410102-0010",
    "AVA410103-0010",
    "AVA410104-0010",
    "AVA410206-0010",
    "AVA410208-0010",
    "AVA420210-0010",
    "AVA420212-0010",
    "AVA420214-0010",
    "AVA420216-0010",
    "AVA430218-0010",
    "AVA430220-0010",
    "AVA430222-0010",
    "AVA430224-0010",
    "AVB01010-0210",
    "AVB01010-0230",
    "AVB01020-0210",
    "AVB01020-0230",
    "AVB01030-0210",
    "AVB01030-0230",
    "AVB01040-0210",
    "AVB01040-0230",
    "AVB01050-0210",
    "AVB01050-0230",
    "AVB01060-0210",
    "AVB01060-0230",
    "AVB01070-0210",
    "AVB01070-0230",
    "AVB01080-0210",
    "AVB01080-0230",
    "AVB02080-0210",
    "AVB02080-0230",
    "AVB02100-0210",
    "AVB02100-0230",
    "AVB02120-0210",
    "AVB02120-0230",
    "AVB02140-0210",
    "AVB02140-0230",
    "AVB02160-0210",
    "AVB02160-0230",
    "AVB03120-0210",
    "AVB03120-0230",
    "AVB03150-0210",
    "AVB03150-0230",
    "AVB03180-0210",
    "AVB03180-0230",
    "AVB03210-0210",
    "AVB03210-0230",
    "AVB03240-0210",
    "AVB03240-0230",
    "AVC11010-0010",
    "AVC11020-0010",
    "AVC11030-0010",
    "AVC12010-0010",
    "AVC12020-0010",
    "AVC12030-0010",
    "AVD14013-0010",
    "AVD14013-0012",
    "AVD14013-0018",
    "AVD14023-0010",
    "AVD14023-0011",
    "AVD14023-0012",
    "AVD14023-0018",
    "AVD14033-0010",
    "AVD14033-0011",
    "AVD14033-0012",
    "AVD14033-0018",
    "AVD54013-0010",
    "AVD94010-0010",
    "AVD94020-0010",
    "AVD95040-0010",
    "AVD97010-0010",
    "AVD98040-0010",
    "AVE14043-0010",
    "AVE14043-0011",
    "AVE14043-0012",
    "AVE14043-0018",
    "AVE14063-0010",
    "AVE14063-0011",
    "AVE14063-0012",
    "AVE14063-0018",
    "AVE14083-0010",
    "AVE14083-0011",
    "AVE14083-0012",
    "AVE14083-0018",
    "AVE14103-0010",
    "AVE14103-0011",
    "AVE14103-0012",
    "AVE14103-0018",
    "AVE14123-0010",
    "AVE14123-0011",
    "AVE14123-0012",
    "AVE14123-0018",
    "AVE14143-0010",
    "AVE14143-0011",
    "AVE14143-0012",
    "AVE14143-0018",
    "AVE14163-0010",
    "AVE14163-0011",
    "AVE14163-0012",
    "AVE14163-0018",
    "AVE54043-0010",
    "AVE54063-0010",
    "AVE54083-0010",
    "AVE54103-0010",
    "AVE54123-0010",
    "AVU101100-0010",
    "AVU101200-0010",
    "AVU101300-0010",
    "AVU14010-0010",
    "AVU14010-0012",
    "AVU14010-0019",
    "AVU14010-0030",
    "AVU14020-0010",
    "AVU14020-0012",
    "AVU14020-0019",
    "AVU14020-0030",
    "AVU14030-0010",
    "AVU14030-0012",
    "AVU14030-0019",
    "AVU14030-0030",
    "AVU14040-0010",
    "AVU14040-0019",
    "AVU14040-0030",
    "AVU14050-0010",
    "AVU14050-0012",
    "AVU14050-0019",
    "AVU14050-0030",
    "AVU14060-0010",
    "AVU14060-0012",
    "AVU14060-0019",
    "AVU14060-0030",
    "AVU14070-0010",
    "AVU14070-0012",
    "AVU14070-0019",
    "AVU14070-0030",
    "AVU14080-0010",
    "AVU14080-0012",
    "AVU14080-0019",
    "AVU14080-0030",
    "AVU15080-0010",
    "AVU15080-0012",
    "AVU15080-0019",
    "AVU15080-0030",
    "AVU15100-0010",
    "AVU15100-0012",
    "AVU15100-0019",
    "AVU15100-0030",
    "AVU15120-0010",
    "AVU15120-0012",
    "AVU15120-0019",
    "AVU15120-0030",
    "AVU15140-0010",
    "AVU15140-0012",
    "AVU15140-0019",
    "AVU15140-0030",
    "AVU15160-0010",
    "AVU15160-0012",
    "AVU15160-0019",
    "AVU15160-0030",
    "AVU16120-0010",
    "AVU16120-0012",
    "AVU16120-0019",
    "AVU16120-0030",
    "AVU16150-0010",
    "AVU16150-0012",
    "AVU16150-0019",
    "AVU16150-0030",
    "AVU16180-0010",
    "AVU16180-0012",
    "AVU16180-0019",
    "AVU16180-0030",
    "AVU16210-0010",
    "AVU16210-0012",
    "AVU16210-0019",
    "AVU16210-0030",
    "AVU16240-0010",
    "AVU16240-0012",
    "AVU16240-0019",
    "AVU16240-0030",
    "AVU94010-0010",
    "ADA45015-0030",
    "ADA59010-0030",
    "ADA59080-0030",
    "ADA59210-0030",
    "ADA59280-0030",
    "ADI59010-0057",
    "ADI59080-0057",
    "ADI59210-0057",
    "ADI59280-0057",
    "ADU45015-0030",
    "ADU59010-0030",
    "ADU59080-0030",
    "ADU59210-0030",
    "ADU59280-0030",
    "AEA502000-0010",
    "AEA520208-0010",
    "AEA520212-0010",
    "AEA520216-0010",
    "AEA530216-0010",
    "AEA530220-0010",
    "AEA530224-0010",
    "AMI10105-0710",
    "AMI10105-0757",
    "AMI10300-0010",
    "AMI10300-0057",
    "AMI10410-0010",
    "AMI10410-0057",
    "AMI10510-0010",
    "AMI10510-0057",
    "AMI10620-0010",
    "AMI10620-0057",
    "AMI10700-0010",
    "AMI10700-0057",
    "AMI10800-0010",
    "AMI10800-0057",
    "AMI10911-0010",
    "AMI10911-0057",
    "AMI10912-0010",
    "AMI10912-0057",
    "AMI10913-0010",
    "AMI10913-0057",
    "AMI10914-0010",
    "AMI10914-0057",
    "AMI11000-0080",
    "AMI11110-0010",
    "AMI11110-0057",
    "AMI11200-0010",
    "AMI11200-0057",
    "AMI11300-0000",
    "AMI11400-0010",
    "AMI11400-0057",
    "AMI11603-0010",
    "AMI11603-0057",
    "AMI12300-0080",
    "AMI50-3001",
    "AMI50-3002",
    "AMI50-3003",
    "AMI50-3004",
    "AMI50-3005",
    "AMI50-3006",
    "AMI50-3007",
    "AMI50-3008",
    "AMI50-3010",
    "AMI50-3011",
    "AMI50-3012",
    "AMI50-3013",
    "AZC41000-0010",
    "AZC50000-0010",
    "AZF50000-0010",
    "AZF50000-0015",
    "BDA1000-000",
    "CAE1001-0150",
    "CAE1001-0151",
    "CAE1001-0156",
    "CAE1002-0150",
    "CAE1002-0151",
    "CAE1002-0156",
    "CAE1003-0150",
    "CAE1003-0151",
    "CAE1003-0156",
    "CAE3003-IP-0150",
    "CAE3003-IP-0156",
    "CAE3303-IP-0156",
    "CAE3403-IP-0150",
    "CAE3403-IP-0156",
    "KTU11051-0010",
    "M30U100000-0001",
    "M30U100000-0002",
    "M30U100000-0003",
    "M30U100000-0004",
    "M30U111000-0001",
    "M30U111000-0002",
    "M30U111000-0003",
    "M30U111100-0003",
    "M30U111111-0001",
    "M30U200000-0001",
    "M30U300000-0004",
    "M30U300000-0005",
    "M30U300000-0012",
    "M30U300000-0013",
    "M30U300000-0014",
    "M30U330000-0003",
    "M30U330000-0005",
    "M30U400000-0002",
    "M30U400000-0003",
    "M30U400000-0004",
    "M30U400000-0005",
    "M30U400000-0007",
    "M30U500000-0005",
    "M30U500000-0006",
    "M30U500000-0012",
    "M30U600000-0001",
    "M30U600000-0003",
    "NPAK01-EN",
    "PAK01-EN",
    "PAK01-EN/E",
    "PAK02-EN",
    "PAK02-EN/E",
    "PAK03-EN",
    "PAK03-EN/E",
    "PAK04-EN",
    "PAK04-EN/E",
    "PAK05-EN",
    "PAK05-EN/E",
    "PAK06-EN",
    "PAK06-EN/E",
    "PAK07-EN",
    "PAK07-EN/E",
    "PAK08-EN",
    "PAK08-EN/E",
    "PDS01-EB/04",
    "PDS01-EN/04",
    "PDS01-WS/04",
    "PDS02-EB/04",
    "PDS02-EN/04",
    "PDS02-WS/04",
    "PDS03-EB/04",
    "PDS03-EN/04",
    "PDS03-WS/04",
    "PDT04-EB/04",
    "PDT04-EN/04",
    "PDT04-WS/04",
    "PDT05-EB/04",
    "PDT05-EN/04",
    "PDT05-WS/04",
    "PES04-EB/04",
    "PES04-EN/04",
    "PES04-WS/04",
    "PES06-EB/04",
    "PES06-EN/04",
    "PES06-WS/04",
    "PES08-EB/04",
    "PES08-EN/04",
    "PES08-WS/04",
    "PES10-EB/04",
    "PES10-EN/04",
    "PES10-WS/04",
    "PES12-EB/04",
    "PES12-EN/04",
    "PES12-WS/04",
    "PES14-EB/04",
    "PES14-EN/04",
    "PES14-WS/04",
    "PES16-EB/04",
    "PES16-EN/04",
    "PES16-WS/04",
    "PES18-EB/04",
    "PES18-EN/04",
    "PES18-WS/04",
    "PES20-EB/04",
    "PES20-EN/04",
    "PES20-WS/04",
    "PET12-EB/04",
    "PET12-EN/04",
    "PET12-EN/E",
    "PET12-WS/04",
    "PET14-EB/04",
    "PET14-EN/04",
    "PET14-EN/E",
    "PET14-WS/04",
    "PET16-EB/04",
    "PET16-EN/04",
    "PET16-EN/E",
    "PET16-WS/04",
    "PET18-EB/04",
    "PET18-EN/04",
    "PET18-EN/E",
    "PET18-WS/04",
    "PET20-EB/04",
    "PET20-EN/04",
    "PET20-EN/E",
    "PET20-WS/04",
    "PET22-EB/04",
    "PET22-EN/04",
    "PET22-EN/E",
    "PET22-WS/04",
    "PET24-EB/04",
    "PET24-EN/04",
    "PET24-WS/04",
    "PET26-EB/04",
    "PET26-EN/04",
    "PET26-EN/E",
    "PET26-WS/04",
    "PET28-EB/04",
    "PET28-EN",
    "PET28-EN/04",
    "PET28-EN/E",
    "PET28-WS/04",
    "PSK01-EN",
    "PSK02-EN",
    "PUK01/1-EB",
    "PUK01/1-EN",
    "PUK01/1-EN/E",
    "PUK01/1-ES",
    "PUK01/1-WS",
    "PUK02/1-EB",
    "PUK02/1-EN",
    "PUK02/1-EN/E",
    "PUK02/1-ES",
    "PUK02/1-WS",
    "PUK03/1-EB",
    "PUK03/1-EN",
    "PUK03/1-EN/E",
    "PUK03/1-ES",
    "PUK03/1-WS",
    "PUK04/1-EB",
    "PUK04/1-EN",
    "PUK04/1-EN/E",
    "PUK04/1-ES",
    "PUK04/1-WS",
    "PUK05/1-EB",
    "PUK05/1-EN",
    "PUK05/1-EN/E",
    "PUK05/1-ES",
    "PUK05/1-WS",
    "PUK06/1-EN",
    "PUK06/1-EN/E",
    "PUK06/1-ES",
    "PUK06/1-WS",
    "PUK07/1-EN",
    "PUK07/1-EN/E",
    "PUK07/1-EN/P",
    "PUK07/1-ES",
    "PUK07/1-WS",
    "PUK08/1-EN",
    "PUK08/1-EN/E",
    "PUK08/1-ES",
    "PUK08/1-WS",
    "PUK08/2-EB",
    "PUK08/2-EN",
    "PUK08/2-EN/E",
    "PUK08/2-ES",
    "PUK08/2-WS",
    "PUK09/1-EB",
    "PUK09/1-EN",
    "PUK09/1-EN/E",
    "PUK09/1-ES",
    "PUK09/1-WS",
    "PUK10/1-EB",
    "PUK10/1-EN",
    "PUK10/1-EN/E",
    "PUK10/1-ES",
    "PUK10/1-WS",
    "PUK10/2-EN",
    "PUK10/2-EN/E",
    "PUK10/2-ES",
    "PUK10/2-WS",
    "PUK12/2-EB",
    "PUK12/2-EN",
    "PUK12/2-EN/E",
    "PUK12/2-ES",
    "PUK12/2-WS",
    "PUK12/3-EB",
    "PUK12/3-EN",
    "PUK12/3-EN/E",
    "PUK12/3-ES",
    "PUK12/3-WS",
    "PUK14/2-EB",
    "PUK14/2-EN",
    "PUK14/2-EN/E",
    "PUK14/2-ES",
    "PUK14/2-WS",
    "PUK15/3-EB",
    "PUK15/3-EN",
    "PUK15/3-EN/E",
    "PUK15/3-ES",
    "PUK15/3-WS",
    "PUK16/2-EB",
    "PUK16/2-EN",
    "PUK16/2-EN/E",
    "PUK16/2-ES",
    "PUK16/2-WS",
    "PUK18/2-EB",
    "PUK18/2-EN",
    "PUK18/2-EN/E",
    "PUK18/2-ES",
    "PUK18/2-WS",
    "PUK18/3-EB",
    "PUK18/3-EN",
    "PUK18/3-EN/E",
    "PUK18/3-ES",
    "PUK18/3-WS",
    "PUK20/2-EB",
    "PUK20/2-EN",
    "PUK20/2-EN/E",
    "PUK20/2-ES",
    "PUK20/2-WS",
    "PUK21/3-EB",
    "PUK21/3-EN",
    "PUK21/3-EN/E",
    "PUK21/3-ES",
    "PUK21/3-WS",
    "PUK24/3-EB",
    "PUK24/3-EN",
    "PUK24/3-EN/E",
    "PUK24/3-ES",
    "PUK24/3-WS",
    "PUK27/3-EB",
    "PUK27/3-EN",
    "PUK27/3-EN/E",
    "PUK27/3-ES",
    "PUK27/3-WS",
    "PUK30/3-EB",
    "PUK30/3-EN",
    "PUK30/3-EN/E",
    "PUK30/3-ES",
    "PUK30/3-WS",
    "VKR10-EB",
    "VKR10-EM",
    "VKR10-EN",
    "VKR10-ES",
    "VKR10-WS",
    "AVA630220-0010",
    "AVA620212-0010",
    "AVA620210-0010",
    "AVA610206-0010",
    "AVA610104-0010",
    "AVA610103-0010",
    "AVA630222-0010",
    "AVA630218-0010",
    "AVA620214-0010",
    "AVA620216-0010",
    "AVA610208-0010",
    "AVA610102-0010",
    "AVA630224-0010",
    "AVA610101-0010",
    "ADU64000-0030",
    "CAE2103-0156",
    "CAE2101-0150",
    "CAE2101-0151",
    "CAE2101-0156",
    "CAE2102-0150",
    "CAE2102-0151",
    "CAE2102-0156",
    "CAE2103-0150",
    "CAE2103-0151",
    "AMI12500-0010",
    "AVD14013-0011",
    "AVU14040-0012",
    "KTU11050-0010",
    "KTU11052-0010",
    "KTU11060-0010",
    "KTU11062-0010",
    "KTU11070-0010",
    "KTU11072-0010",
    "KTU11080-0010",
    "KTU11082-0010",
    "KTU11090-0010",
    "KTU11092-0010",
    "KTU11100-0010",
    "KTU11102-0010",
    "KTU11110-0010",
    "KTU11112-0010",
    "KTU11120-0010",
    "KTU11122-0010",
    "KTU12100-0010",
    "KTU12102-0010",
    "KTU12120-0010",
    "KTU12122-0010",
    "KTU12140-0010",
    "KTU12142-0010",
    "KTU12160-0010",
    "KTU12162-0010",
    "KTU12180-0010",
    "KTU12182-0010",
    "KTU12200-0010",
    "KTU12202-0010",
    "KTU13150-0010",
    "KTU13152-0010",
    "KTU13180-0010",
    "KTU13182-0010",
    "KTU13210-0010",
    "KTU13212-0010",
    "PFS08-EN",
    "PFS12-EN",
    "PFS16-EN",
    "PFS20-EN",
    "PFS24-EN",
    "PFS28-EN",
    "PFS32-EN",
    "PUK06/1-EB",
    "PUK07/1-EB",
    "PUK08/1-EB",
    "PUK10/2-EB",
    "BDA1000-001",
    "BDA1000-002",
    "ZAA2009-0030",
    "ZAA2010-0010",
    "AMI10200-0057",
    "AVN01010-0210",
    "ADU14031-0010",
    "ADU14033-0010",
    "ADU14041-0010",
    "ADU14043-0010",
    "ADU14131-0010",
    "ADU14143-0010",
    "ADU14233-0010",
    "ADU14133-0010",
    "ADU32112-0010",
    "ADU33112-0010",
    "ADU32013-0010",
    "ADU32013-0030",
    "ADU31013-0010",
    "ADU31013-0030",
    "ADU24113-0010",
    "ADU31214-0030",
    "ADU34114-0030",
    "ADU32213-0030",
    "ADU31113-0030",
    "ADU31212-0010",
    "ADU14141-0010",
    "ADU32114-0010",
    "ADU34013-0010",
    "ADU31213-0010",
    "ADU32114-0030",
    "ADU14243-0010",
    "ADU14241-0010",
    "ADU32113-0030",
    "ADU31212-0030",
    "ADU31214-0010",
    "ADU33112-0030",
    "ADU34112-0030",
    "ADU31114-0030",
    "ADU33213-0030",
    "ADU34012-0030",
    "ADU33113-0010",
    "ADU31112-0030",
    "ADU33113-0030",
    "ADU32012-0030",
    "ADU33012-0010",
    "ADU34114-0010",
    "ADU14111-0010",
    "ADU32113-0010",
    "ADU33114-0010",
    "ADU34112-0010",
    "ADU31014-0010",
    "ADU32014-0010",
    "ADU33014-0010",
    "ADU31213-0030",
    "ADU33114-0030",
    "ADU34113-0030",
    "ADU14211-0010",
    "ADU31113-0010",
    "ADU32042-0010",
    "ADU14011-0010",
    "ADU31114-0010",
    "ADU24043-0010",
    "ADU32112-0030",
    "ADU32014-0030",
    "ADU33212-0010",
    "ADU33212-0030",
    "ADU33214-0030",
    "ADU24143-0010",
    "ADU32214-0010",
    "ADU24243-0010",
    "ADU24233-0010",
    "ADU24133-0010",
    "ADU24033-0010",
    "ADU14113-0010",
    "ADU31112-0010",
    "ADU33013-0010",
    "ADU32213-0010",
    "ADU31012-0030",
    "ADU34113-0010",
    "ADU32212-0030",
    "ADU34012-0010",
    "ADU32214-0030",
    "ADU33213-0010",
    "ADU33214-0010",
    "ADU64200-0030",
    "ASA420212-0010",
    "ASA420216-0010",
    "ASA410104-0010",
    "ASA410103-0010",
    "ASA430224-0010",
    "ASA410101-0010",
    "ASA410108-0010",
    "ASA401000-0010",
    "ADU64205-0030",
    "ASA420210-0010",
    "ASA430218-0010",
    "ASA420214-0010",
    "ASA430222-0010",
    "ASA410102-0010",
    "ASA410106-0010",
    "ASA410206-0010",
    "ASA410208-0010",
    "ASA430220-0010",
    "AZC50000-0015",
    "CAE3100-IP-0150",
    "ASA110102-0010",
    "CAE3404-IP-0150",
    "CAE3404-IP-0156",
    "CAE3006-BUS-0150",
    "CAE3006-BUS-0156",
    "CAE3306-BUS-0156",
    "ASU600216-0030",
    "AVU600112-0030",
    "ASU600218-0030",
    "AVU600214-0030",
    "ASU600220-0030",
    "AVU600216-0030",
    "ASU600222-0030",
    "AVU600218-0030",
    "ASU600224-0030",
    "AVU600220-0030",
    "ASU600101-0030",
    "ASU600103-0030",
    "AVU600101-0030",
    "AVU600222-0030",
    "ASU600104-0030",
    "AVU600102-0030",
    "AVU600224-0030",
    "ASU600105-0030",
    "AVU600103-0030",
    "CAE3004-IP-0150",
    "CAE3004-IP-0156",
    "ASU600106-0030",
    "AVU600104-0030",
    "CAE3304-IP-0156",
    "AVU600105-0030",
    "ASU600102-0030",
    "ASU600108-0030",
    "AVU600106-0030",
    "ASU600109-0030",
    "AVU600107-0030",
    "ASU600110-0030",
    "AVU600108-0030",
    "ASU600111-0030",
    "AVU600109-0030",
    "ASU600112-0030",
    "AVU600110-0030",
    "ASU600214-0030",
    "AVU600111-0030",
    "PVKTU2T-IP-R9010",
    "CAE2101-1150",
    "ASU600110-0010",
    "ASU600107-0010",
    "ASU600216-0010",
    "AVU600112-0010",
    "AVU600216-0010",
    "ASU600214-0010",
    "AVU600107-0010",
    "ASU600109-0010",
    "PVKTU2T-IP-R7016",
    "AVU600106-0010",
    "AVU600104-0010",
    "AVU600218-0010",
    "AVU600222-0010",
    "ASU600111-0010",
    "AVU600108-0010",
    "AVU600110-0010",
    "ASU600102-0010",
    "AVU600103-0010",
    "PES20-EN/03",
    "ASU600218-0010",
    "ASU600224-0010",
    "ASU600103-0010",
    "AVU600224-0010",
    "AVU600105-0010",
    "ASU600220-0010",
    "ASU600222-0010",
    "ASU600101-0010",
    "ASU600104-0010",
    "ASU600108-0010",
    "AVU600109-0010",
    "AVU600214-0010",
    "AVU600220-0010",
    "AVE54XXX-XXXX-04A",
    "ASU600105-0010",
    "ASU600106-0010",
    "AVU600111-0010",
    "ASU600112-0010",
    "AVU600101-0010",
    "AVU600102-0010",
    "AVU400102-0030",
    "AVU400101-0030",
    "AVU400104-0030",
    "AVU400103-0030",
    "AVU400105-0030",
    "AVU400106-0030",
    "AVU400108-0030",
    "AVU400107-0030",
    "AVU400110-0030",
    "AVU400109-0030",
    "AVU400111-0030",
    "AVU400112-0030",
    "AVU400216-0030",
    "AVU400214-0030",
    "AVU400218-0030",
    "AVU400220-0030",
    "AVU400222-0030",
    "AVU400224-0030",
    "AVU400101-0010",
    "AVU400102-0010",
    "AVU400104-0010",
    "AVU400103-0010",
    "AVU400105-0010",
    "AVU400106-0010",
    "AVU400107-0010",
    "AVU400108-0010",
    "AVU400109-0010",
    "AVU400110-0010",
    "AVU400111-0010",
    "AVU400112-0010",
    "AVU400216-0010",
    "AVU400214-0010",
    "AVU400218-0010",
    "AVU400220-0010",
    "AVU400222-0010",
    "AVU400224-0010",
    "AVA610206-0019",
    "AVA610103-0017",
    "AVA630218-0017",
    "AVA610208-0019",
    "AVA610104-0017",
    "AVA630220-0017",
    "AVA620210-0019",
    "AVA610206-0017",
    "AVA630222-0017",
    "AVA620212-0019",
    "AVA610208-0017",
    "AVA630224-0017",
    "ASA120216-0017",
    "ASA130218-0017",
    "ASA130220-0017",
    "AVA620214-0019",
    "ASA130222-0017",
    "AVA620216-0019",
    "ASA130224-0017",
    "AVA630218-0019",
    "AVA620210-0017",
    "AVA610101-0019",
    "AVA630220-0019",
    "AVA620212-0017",
    "AVA610102-0019",
    "AVA630222-0019",
    "AVA610103-0019",
    "AVA630224-0019",
    "AVA620214-0017",
    "AVA610104-0019",
    "AVA610101-0017",
    "AVA620216-0017",
    "ASA110104-0019",
    "ASA110104-0017",
    "ASA110102-0019",
    "ASA120214-0017",
    "ASA110101-0017",
    "ASA110101-0019",
    "ASA110208-0017",
    "ASA110208-0019",
    "ASA120216-0019",
    "ASA120212-0017",
    "ASA120210-0019",
    "ASA130218-0019",
    "ASA130224-0019",
    "ASA110103-0019",
    "ASA130220-0019",
    "ASA110102-0017",
    "ASA110206-0017",
    "ASA120212-0019",
    "ASA120210-0017",
    "ASA110206-0019",
    "ASA120214-0019",
    "ASA110103-0017",
    "ASA130222-0019",
    "AMI10810-0010",
    "AMI10810-0057",
    "ADU64000-0130",
    "ADU64200-0130",
    "AVA610102-0017",
    "ASU600102-0019",
    "ASU600101-0019",
    "ASU600214-0017",
    "ASU600103-0017",
    "ASU600110-0017",
    "AVU600216-0019",
    "AVU600110-0019",
    "AVU600218-0019",
    "ASU600106-0017",
    "ASU600104-0019",
    "ASU600106-0019",
    "ASU600110-0019",
    "AVU600222-0017",
    "AVU600108-0017",
    "AVU600106-0017",
    "ASU600104-0017",
    "ASU600214-0019",
    "ASU600222-0019",
    "AVU600110-0017",
    "AVU600103-0017",
    "AVU600111-0019",
    "ASU600220-0017",
    "ASU600109-0019",
    "AVU600105-0017",
    "AVU600104-0017",
    "AVU600220-0017",
    "ASU600112-0017",
    "ASU600218-0017",
    "ASU600103-0019",
    "ASU600224-0017",
    "ASU600112-0019",
    "ASU600107-0019",
    "AVU600107-0017",
    "AVU600214-0017",
    "ASU600216-0019",
    "ASU600220-0019",
    "AVU600214-0019",
    "AVU600102-0019",
    "AVU600101-0019",
    "AVU600109-0019",
    "AVU600102-0017",
    "AVU600111-0017",
    "AVU600216-0017",
    "AVU600218-0017",
    "AVU600109-0017",
    "AVU600101-0017",
    "AVU600112-0017",
    "AVU600224-0017",
    "ASU600216-0017",
    "AVU600103-0019",
    "AVU600112-0019",
    "AVU600105-0019",
    "ASU600105-0017",
    "AVU600224-0019",
    "AVU600107-0019",
    "ASU600107-0017",
    "ASU600109-0017",
    "ASU600108-0017",
    "AVU600108-0019",
    "ASU600111-0017",
    "AVU600104-0019",
    "ASU600222-0017",
    "AVU600106-0019",
    "AVU600220-0019",
    "AVU600222-0019",
    "ASU600101-0017",
    "ASU600111-0019",
    "ASU600218-0019",
    "ASU600108-0019",
    "ASU600102-0017",
    "ASU600105-0019",
    "ASU600224-0019",
    "TPDS02-EN",
    "AVE54XXX-3011",
    "AVE14040-0010"
  ],
  "controlUnits": [
    "BVS100-SG",
    "BVS20-SG",
    "BVS20-SG/02",
    "BVS30-SG",
    "NBV2600-0400",
    "NBV3200-0500",
    "NBV3210-0500",
    "NGV1011-0400",
    "NVV1000-0400",
    "NWV1000-0400",
    "PSG01-SG",
    "PSG02-SG",
    "VBVS05-SG/02",
    "VBVS30-SG",
    "VBVS05-SG",
    "NBV2600-3400",
    "BVS40-SG"
  ],
  "Funktionserweiterung": [
    "BMN2-EB",
    "BRE2-EB",
    "BRE2-SG",
    "FAA1100-0600",
    "FAA1200-0400",
    "FAA1250-0400",
    "FBA4100-0119",
    "FBA4100-0210",
    "FBC2000-0400",
    "FBC3000-0600",
    "FBC3600-0400",
    "FBI4500-0100",
    "FBO1100-0400",
    "FBO1110-0400",
    "FBO1210-0400",
    "FBS1100-0900",
    "FBS1105-0900",
    "FFI0001-0000",
    "FFL0002-0000",
    "FFL0003-0000",
    "FFL0004-0000",
    "FFL1000-1",
    "FFL2100-0",
    "FIL1101-0140",
    "FIS1100-0600",
    "FNA1000-0400",
    "FVK1202-0",
    "FVK2200-0300",
    "FVK2201-0300",
    "FVK2202-0300",
    "FVK3210-0",
    "FVK3220-0",
    "FVK3230-0",
    "FVK3240-0",
    "FVK4224-0",
    "FVK4225-0",
    "FVU1200-0600",
    "FVU1210-0600",
    "FVU1401-0400",
    "FVW1001-0600",
    "FVW2000-0600",
    "FVW3030-0600",
    "FVW3040-0600",
    "FVY1200-0400",
    "FVY1200-0600",
    "FVY1400-0400",
    "FVY3200-0600",
    "PC1-I",
    "SK10-SG",
    "TOER2-EB",
    "TRE1-EB",
    "TRE2-EB",
    "VKA10-GH",
    "FAA1100-0400",
    "FBO1200-0400",
    "FBP2000-0000",
    "FFL0001-0000",
    "FFL2000-0",
    "FFL2200-0",
    "FIL5100-0145",
    "VSW05-SG",
    "FFL0005-0000",
    "FFL3000-0",
    "FFL3100-0",
    "FFL3200-0",
    "FEZ1000-0400",
    "FBI5100-0400",
    "FVK4215-0",
    "FAA3100-0300",
    "FFI0002-0000",
    "KBRE2-SG"
  ],
  "Gateway": [
    "FBI1210-0",
    "FBI6119-0400",
    "FBI6121-0400",
    "FBI6122-0400",
    "FBI6123-0400",
    "FBI6124-0400",
    "FBI6132-0400",
    "FEW1000-0400",
    "FBI6126-0401",
    "FBI6127-0400"
  ],
  "Zubehoer1": [
    "ZAM1101-0010",
    "ZAS1312-0010",
    "ZAS1334-0010",
    "ZAS1356-0010",
    "ZAU4001-0002",
    "ZIA5001-0145",
    "ZIA5003-0145",
    "ZIA5005-0145",
    "ZIA5006-0145",
    "ZIT3030-0010",
    "ZIT3222-0030",
    "ZIT5000-0030"
  ],
  "others": []
}